import React from "react"
import tw, { styled } from "twin.macro"

import { SlideProps } from "."

import Container from "../components/container"
import NextPageButton from "../components/nextPageButton"
import SlideSection from "../components/slideSection"
import TimeSelector from "../components/timeSelector"
import TitleHowFast from "../svgs/titleHowFast"
import NextPageContainer from "../components/nextPageContainer"

const Columns = styled.div`
  ${tw`flex flex-col lg:flex-row items-center justify-center w-full`}
`

const MediumThreeQuarters = styled.div`
  ${tw`lg:w-3/5 flex flex-col items-center justify-center`}
`

const MediumOneQuarter = styled.div`
  width: 15% ${tw`lg:w-2/5 flex flex-col items-end justify-center`};
`

const Instructions = styled.p`
  ${tw`hidden md:block w-64 text-center font-sans text-sm mb-6`}
`

const InstructionsSmall = styled.p`
  ${tw`md:hidden w-64 text-center font-sans text-sm mb-6`}
`

const TimeSlide: React.SFC<SlideProps> = ({
  slideVisible,
  nextButtonClicked,
}) => {
  return (
    <SlideSection autoHeightResponsive>
      <div css={[tw`flex flex-col justify-center items-center`]}>
        <Container>
          <Columns>
            <MediumOneQuarter>
              <TitleWrapper>
                <TitleHowFast css={[tw`-mt-24`]} />
                <Instructions>
                  Click the hours per week or number of months to find out how
                  quickly you could complete the course.
                </Instructions>
              </TitleWrapper>
            </MediumOneQuarter>
            <MediumThreeQuarters>
              <TimeSelector slideVisible={slideVisible} />
            </MediumThreeQuarters>
          <InstructionsSmall>
            Click the hours per week or number of months to find out how quickly
            you could complete the course.
          </InstructionsSmall>
          </Columns>
        </Container>

        <NextPageContainer>
          <NextPageButton
            onClick={nextButtonClicked}
            label="What will I learn"
          />
        </NextPageContainer>
      </div>
    </SlideSection>
  )
}

const TitleWrapper = styled.div`
  ${tw`flex flex-col items-center justify-center mt-24 md:mt-0`}
`

export default TimeSlide
